import { useState } from "react";
import { Camera, CircleDollarSign, ReceiptText, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function SmartInput({ onSaved, onAddIncome }) {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null);
  const [form, setForm] = useState({ amount: "", date: new Date().toISOString().slice(0, 10), note: "", category: "Otros" });
  const [error, setError] = useState("");

  const close = () => {
    setMode(null);
    setError("");
  };

  async function saveManual() {
    if (Number(form.amount) <= 0) {
      setError("Escribe un monto mayor a cero.");
      return;
    }
    try {
      await api.post("/smart-input/manual", { type: mode, ...form, amount: Number(form.amount) }, { withCredentials: true });
      close();
      onSaved();
    } catch (issue) {
      setError(issue.response?.data?.detail || "No pudimos guardar el movimiento.");
    }
  }

  return (
    <>
      <section className="smart-actions" data-testid="smart-input-actions">
        <button onClick={() => onAddIncome ? onAddIncome() : setMode("income")} data-testid="add-income-button">
          <CircleDollarSign />
          Añadir ingreso
        </button>
        <button onClick={() => setMode("expense")} data-testid="add-expense-button">
          <ReceiptText />
          Añadir gasto
        </button>
        <button onClick={() => navigate("/importar")} data-testid="scan-receipt-button">
          <Camera />
          Escanear ticket
        </button>
      </section>
      {mode && (
        <div className="smart-overlay" data-testid="smart-input-modal">
          <div className="smart-modal">
            <button className="modal-close" data-testid="smart-modal-close-button" onClick={close} aria-label="Cerrar">
              <X />
            </button>
            <h2>{mode === "income" ? "Añadir ingreso" : "Añadir gasto"}</h2>
            <input type="number" placeholder="Monto" value={form.amount} onChange={(event) => setForm({ ...form, amount: event.target.value })} data-testid="smart-amount-input" />
            <input type="date" value={form.date} onChange={(event) => setForm({ ...form, date: event.target.value })} data-testid="smart-date-input" />
            <input placeholder="Categoría" value={form.category} onChange={(event) => setForm({ ...form, category: event.target.value })} data-testid="smart-category-input" />
            <input placeholder="Nota" value={form.note} onChange={(event) => setForm({ ...form, note: event.target.value })} data-testid="smart-note-input" />
            <button className="primary" onClick={saveManual} data-testid="save-smart-entry-button">Guardar</button>
            {error && <p className="billing-error" data-testid="smart-input-error">{error}</p>}
          </div>
        </div>
      )}
    </>
  );
}